<div class="header">
  <div class="content" [ngsRevealSet]="{ reset:false, scale:1, distance: '20px'}" [ngsInterval]="50" [ngsSelector]="'.pageTitle'">
    <div class="contentInner">
      <div class="pageTitle">
        <h1 class="headline">Dash Enterprise</h1>
      </div>
    </div>
    <app-enterprise-tab-navigator></app-enterprise-tab-navigator>
  </div>
</div>

<div class="content">
  <div class="contentInner">
    <h1 class="sectionHeader">Using Dash with MDM</h1>
    <p class="intro">If you are using an MDM solution in your business, Dash Enterprise allows you to deploy and
      configure Dash using <i>managed configurations</i>.  Configure Dash's settings and also the behaviour of your
      display device (for example by turning on kiosk mode to lock the device to Dash).
    </p>

    <p>We have created a standalone guide that shows you how to configure Dash using your MDM service:</p>

    <a class="button" href="/assets/Dash-Enterprise-MDM-configuration-guide.pdf" target="_blank">Download guide</a>

  </div>
</div>
